module.exports = __webpack_public_path__ + "static/Technically-Perfect-Pizza-1-592f655c2bb7197297ef00aa2cd8493d.mp4";